import React from 'react';
import clsx from 'clsx';

export const CompanyIcon = ({ width, height, fill1, fill2, className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 296 100'
      className={clsx('icon', 'icon-company', className)}
    >
      <g>
        <path
          d='M188 0H108C102.477 0 98 4.47715 98 10V90C98 95.5229 102.477 100 108 100H188C193.523 100 198 95.5229 198 90V10C198 4.47715 193.523 0 188 0Z'
          fill={fill1}
        />
        <path d='M68 8H62V14H60V8H54V6H60V0H62V6H68V8Z' fill={fill1} />
        <path d='M14 58H8V64H6V58H0V56H6V50H8V56H14V58Z' fill={fill1} />
        <path d='M54 94H48V100H46V94H40V92H46V86H48V92H54V94Z' fill={fill1} />
        <path
          opacity='0.3'
          d='M80 50.714H75.714V55H74.286V50.714H70V49.286H74.286V45H75.715V49.286H80V50.714Z'
          fill={fill1}
        />
        <path
          opacity='0.3'
          d='M226 50.714H221.714V55H220.286V50.714H216V49.286H220.286V45H221.715V49.286H226V50.714Z'
          fill={fill1}
        />
        <path
          d='M242 94H236V100H234V94H228V92H234V86H236V92H242V94Z'
          fill={fill1}
        />
        <path d='M256 8H250V14H248V8H242V6H248V0H250V6H256V8Z' fill={fill1} />
        <path
          d='M296 65H290V71H288V65H282V63H288V57H290V63H296V65Z'
          fill={fill1}
        />
        <path d='M25 14H30V19H25V14Z' fill={fill2} />
        <path d='M80 81H85V86H80V81Z' fill={fill2} />
        <path d='M267 81H272V86H267V81Z' fill={fill2} />
        <path d='M226 14H231V19H226V14Z' fill={fill2} />
        <path
          d='M148.5 36V25H121V74.5H176V36H148.5ZM132 69H126.5V63.5H132V69ZM132 58H126.5V52.5H132V58ZM132 47H126.5V41.5H132V47ZM132 36H126.5V30.5H132V36ZM143 69H137.5V63.5H143V69ZM143 58H137.5V52.5H143V58ZM143 47H137.5V41.5H143V47ZM143 36H137.5V30.5H143V36ZM170.5 69H148.5V63.5H154V58H148.5V52.5H154V47H148.5V41.5H170.5V69ZM165 47H159.5V52.5H165V47ZM165 58H159.5V63.5H165V58Z'
          fill={fill2}
        />
      </g>
    </svg>
  );
};

CompanyIcon.defaultProps = {
  fill1: 'var(--coronation-blue)',
  fill2: 'var(--cobalite)',
  width: 296,
  height: 100,
  className: ''
};
